import gql from 'graphql-tag';

export default gql`
  mutation EditTestMutation($request: HashimotoTestEditInputType!) {
    hashimoto {
      hashimotoTestEdit(testEditData: $request) {
        __typename
        ... on BasicMutationSuccess {
          successCode: code
        }
        ... on UnauthorizedException {
          unauthorizedCode: code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
